export const IMG_SRC_BASE_PROFILE_PHOTO = 'data:image/jpeg;base64,';
